<template>
  <b-container id="signin">
    <!-- Cообщения -->
    <div id="app-msgs" class="container"></div>

    <b-row id="content">
      <b-col xl="6" lg="7" md="10">
        <b-card v-if="message" border-variant="warning" class="mb-5" header-tag="h4" header-bg-variant="warning"
                header-text-variant="white"
                :header="$t('login.third-parties.error_h')">
          <template v-slot:default>
            <template v-if="code == CODE_AUTH_OAUTH_NO_EMAIL">
              <div class="mb-3">{{ $t('login.third-parties.error_email', [provider]) }}</div>
            </template>
            <template v-else>
              <div class="mb-3">{{ $t('login.third-parties.other_error') }}</div>
              <em class="mb-3">{{ message }}</em>
            </template>

            <div class="text-secondary mt-3">{{ $t('login.third-parties.error_note') }}</div>
          </template>
        </b-card>

        <h2 class="mb-4">{{ $t("login.h") }}</h2>
        <b-form @submit="onSubmit">
          <b-overlay :show="loading" variant="white" opacity="0.7">
            <!-- ### Email ################################################## -->
            <b-form-group
                id="input-group-1"
                :label="$t('login.form.email.label')"
                label-for="input-1"
            >
              <b-form-input
                  id="input-1"
                  autofocus
                  :disabled="loading"
                  v-model="$v.form.email.$model"
                  :state="validateState('email')"
                  aria-describedby="input-1-ifeedback"
                  :placeholder="$t('login.form.email.ph')"
              ></b-form-input>
              <b-form-invalid-feedback id="input-1-ifeedback">{{
                  $t("form.validEmail")
                }}
              </b-form-invalid-feedback>
            </b-form-group>

            <!-- ### Password ################################################## -->
            <b-form-group
                id="input-group-2"
                :label="$t('login.form.pass.label')"
                label-for="input-2"
            >
              <b-form-input
                  id="input-2"
                  :disabled="loading"
                  v-model="$v.form.password.$model"
                  :placeholder="$t('login.form.pass.ph')"
                  :state="validateState('password')"
                  type="password"
              ></b-form-input>
              <b-form-invalid-feedback>{{
                  $t("form.required")
                }}
              </b-form-invalid-feedback>
            </b-form-group>

            <!-- ### Remember me ################################################## -->
            <b-form-group id="input-group-3">
              <b-form-checkbox
                  v-model="form.remember"
                  :disabled="loading"
                  switch
              >{{ $t("login.form.remember") }}
              </b-form-checkbox
              >
            </b-form-group>
          </b-overlay>

          <b-container class="p-0">
            <div class="mt-3 mb-2 t90p">
              <a :href="URL_TERMS_OS_SERVICE" target="_blank">{{ $t('signup.legal.terms') }}</a> &bull;
              <a :href="URL_PRIVACY_POLICY" target="_blank">{{ $t('signup.legal.policy') }}</a>
            </div>

            <b-row class="mt-4">
              <b-col cols="12" ph="6" class="mb-4 mb-ph-0">
                <b-button
                    type="submit"
                    variant="primary"
                    class="w-100"
                    :disabled="loading"
                >{{ $t("login.form.button") }}
                </b-button
                >
              </b-col>
              <b-col cols="12" ph="1" class="d-block d-ph-none">
                <div class="mb-3 d-ph-none text-center">{{ $t('login.alternative') }}</div>
              </b-col>
              <b-col cols="12" ph="5" class="d-flex justify-content-center justify-content-ph-start pl-ph-5">
                <div class="d-inline-block mr-4">
                  <a id="a-github-id" href="https://github.com/login/oauth/authorize?client_id=e52b53ec12e1c44a5b9d">
                    <svg aria-hidden="true" viewBox="0 0 16 16" version="1.1" data-view-component="true" height="34"
                         width="34" class="octicon octicon-mark-github">
                      <title>Login using Github</title>
                      <g>
                        <path fill-rule="evenodd"
                              d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"></path>
                      </g>
                    </svg>
                  </a>
                </div>

                <div class="d-inline-block">
                  <a id="a-ln-id"
                     href="https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=77jdbom7gw9h3a&redirect_uri=http%3A%2F%2Flocalhost%3A8000%2Fapi%2Foauth%2Flinkedin&state=foobar&scope=r_liteprofile%20r_emailaddress">
                    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34"
                         class="global-nav__logo">
                      <title>Login using LinkedIn</title>
                      <g>
                        <path
                            d="M34,2.5v29A2.5,2.5,0,0,1,31.5,34H2.5A2.5,2.5,0,0,1,0,31.5V2.5A2.5,2.5,0,0,1,2.5,0h29A2.5,2.5,0,0,1,34,2.5ZM10,13H5V29h5Zm.45-5.5A2.88,2.88,0,0,0,7.59,4.6H7.5a2.9,2.9,0,0,0,0,5.8h0a2.88,2.88,0,0,0,2.95-2.81ZM29,19.28c0-4.81-3.06-6.68-6.1-6.68a5.7,5.7,0,0,0-5.06,2.58H17.7V13H13V29h5V20.49a3.32,3.32,0,0,1,3-3.58h.19c1.59,0,2.77,1,2.77,3.52V29h5Z"
                            fill="currentColor"></path>
                      </g>
                    </svg>
                  </a>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </b-form>

        <!-- ### Sign up & Forgot password ###################################### -->
        <div class="router" ref="container">
          <router-link :to="{ name: 'sign-up-form' }">{{
              $t("login.signup")
            }}
          </router-link>
          <router-link to="/forgot-password">{{
              $t("login.forgot")
            }}
          </router-link>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
// @ is an alias to /src
import {validationMixin} from "vuelidate";
import {required, email, or} from "vuelidate/lib/validators";
import store from "@/store/";
import {SETUP_FROM_DATA, SIGN_OUT} from "@/store/consts";
import {CODE_AUTH_UNVERIFIED} from "@/util/errors";
import {CODE_AUTH_OAUTH_NO_EMAIL, URL_SIGN_IN, URL_TERMS_OS_SERVICE, URL_PRIVACY_POLICY} from "@/globals";

export default {
  name: "SignIn",
  mixins: [validationMixin],
  props: ["provider", "code", "message"],
  data() {
    return {
      form: {
        email: "",
        password: "",
        remember: false,
      },
      loading: false,
      root: "root",
    };
  },
  validations: {
    form: {
      email: {
        required,
        custom: or(email, function (value) {
          return value.toLowerCase() === "root";
        }),
      },
      password: {
        required,
      },
    },
  },
  computed: {
    isRoot() {
      return this.form.email === "root";
    },
  },
  mounted() {
    let host = window.location.host;  // hostname - без номера порта!
    let ssoScript = document.createElement('script')
    ssoScript.setAttribute('src', 'https://' + host + '/sso-signin.js')
    document.head.appendChild(ssoScript)
  },
  methods: {
    validateState(name) {
      const {$dirty, $error} = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      this.$store.commit(SIGN_OUT);
      this.$post(
          URL_SIGN_IN,
          {
            login: this.form.email,
            password: this.form.password,
          },
          true
      )
          .then((result) => {
            if (this.form.remember) localStorage.jwt = sessionStorage.jwt;
            store.dispatch(SETUP_FROM_DATA, result.user);

            if (store.getters.isComplete()) {
              if (this.$route.params.nextUrl) {
                this.$router.push(this.$route.params.nextUrl);
              } else {
                if (store.getters.isAdmin) {
                  this.$router.push("/admin");
                } else {
                  this.$router.push("/dashboard");
                }
              }
            }
          })
          .catch((e) => {
            if (e.code == CODE_AUTH_UNVERIFIED) {
              store.dispatch(SETUP_FROM_DATA, e.response.data.result.user);
              this.$router.push({name: "confirmEmail", params: {email: this.$store.getters.unverifiedEmail}});
            } else {
              this.$alert.show(e);
            }
          });
    },
  },
  created() {
    this.CODE_AUTH_OAUTH_NO_EMAIL = CODE_AUTH_OAUTH_NO_EMAIL;
    this.URL_TERMS_OS_SERVICE = URL_TERMS_OS_SERVICE
    this.URL_PRIVACY_POLICY = URL_PRIVACY_POLICY
  }
};
</script>
